define([
	"dojo/_base/declare",
	"csi/heading/TextController",
	"SiteAdmin/Locale"
], function(declare,TextController,Locale) {

	return declare(TextController, {
		toWriter: function() {
			// summary: write operation to set resource for class
			Locale.setResource(this.m_writer, Locale.ATTR_TYPES, this.ren._getLocaleKeys(this._ctx), this.newValue);
		}
	});
});